module.exports = __webpack_public_path__ + "img/exportSaveWhite.07c3f115.svg";